export class Env {
  public static get HOST_ADMIN(): string {
    // 未設定なら同一オリジン（相対）にする。ローカルは localhost:60174、本番は実ホストに追従。
    return process.env.VUE_APP_HOST_ADMIN || '';
  }

  public static get ROUTER_BASE_REMOTE(): string {
    return process.env.VUE_APP_ROUTER_BASE_REMOTE || '/dist/remote-order/';
  }

  public static get ROUTER_BASE_TAKEOUT(): string {
    return process.env.VUE_APP_ROUTER_BASE_TAKEOUT || '/dist/takeout/';
  }

  public static get ROUTER_BASE_SHOP(): string {
    return process.env.VUE_APP_ROUTER_BASE_SHOP || '/dist/shop/';
  }

  public static get APP_VERSION(): string {
    return process.env.VUE_APP_VERSION || 'development';
  }
}
